<template >
  <v-layout row justify-center>
    <v-dialog v-model="show_dialog" persistent max-width="500px">
      <v-card>
        <v-card-title primary-title class="headline info lighten-2">
          <span class="headline">{{title}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form">  
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="mobile" label="会员号" clearable   :rules="[is_valide_mobiel]" :disabled="show_dialog=='edit'"></v-text-field>
              </v-flex>  
              <v-flex xs12 sm8 md8>
                <v-text-field :disabled="spec_info.valid" v-model="name" label="姓名" clearable :rules="[(val)=>val?true:'会员姓名']" hide-details ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-radio-group v-model='sex' row>
                  <v-radio label="男" :value="true" ></v-radio>
                  <v-radio label="女" :value="false"></v-radio>
                </v-radio-group>
              </v-flex>
            
              <v-flex xs12 sm8 md8>
                <v-text-field :disabled="spec_info.valid&&valide_userid()" v-model="spec_info.userid" label="身份证" clearable :rules="[is_valide_userid]"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 v-if="!spec_info.valid && valide_userid()">
                <v-btn  color="success" @click="check_valid">验证</v-btn>
              </v-flex>

              <v-flex xs12>
                <v-text-field v-model="addr_act"  label="收货地址" clearable ></v-text-field>
              </v-flex>
                
              <v-flex xs12 sm6 md6>
                <v-select
                    v-model="user_group"
                    :items="vip_type"
                    label="会员类型"
                    item-value="value"
                    item-text="text"
                    no-data-text="请选择用途"
                    :rules="[(val)=>val?true:'会员类型']"
                    clearable
                    disabled
                  ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                    v-model='signed'
                  :label="`已签署跨境协议: ${signed?'是':'否'}`" 
                  color="red"
                  hint="是否签署跨境协议"
                ></v-switch>
              </v-flex>
                
              <hr>
              <v-flex xs12 sm8 md8>
                <!-- <v-text-field v-model='child.birthday' label="宝贝生日" ></v-text-field> -->
                <v-menu v-model="menu" 
                  ref="menu" 
                  :close-on-content-click="false"
                  :nudge-right="40" transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field
                    slot="activator"
                    v-model="birthday"
                    label="儿童生日"
                    prepend-icon="ti-timer"
                  ></v-text-field>
                  <v-date-picker 
                    ref="picker" 
                    v-model="child.birthday" 
                    @change="save_menu"
                    :max="new Date().toISOString().substr(0, 10)"
                    min= "2010-01-01"
                    no-title clearable scrollable type="date" locale="zh">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menu= false">取消</v-btn>
                  </v-date-picker>
                </v-menu>
<!-- @click="menu = false" -->
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-radio-group v-model='child.sex' row>
                  <v-radio label="男" :value="true" ></v-radio>
                  <v-radio label="女" :value="false"></v-radio>
                </v-radio-group>
              </v-flex>

            </v-layout>
            </v-form> 
          </v-container>
          <!-- <small>*indicates  field</small> -->
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <!-- {{vip_info}} -->
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn color="warning"  @click.native="show_dialog = false">取消</v-btn>
          <v-btn 
            :loading="doing"
            :disabled="doing"
            color="info darken-1"  @click.native="create_record">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {base_api} from "@/api/base_api"   
import isValidCID from "@/lib/is_valid_usercid"
import {selectoption} from "@/api/module/select_options"    
export default {
    //template:``,
    name: '',
    props:{
        width:{
            type:String,
            default:'500px'
        }
    },
    computed:{
        show_dialog:{
          get(){
              return this.$store.state.dialog.show_editvip_dialog;
          },
          set(val){
              // debugger
              if(val == true){
                 if(this.show_dialog == 'add' || this.show_dialog =='edit'||this.show_dialog == 'valid')
                    return;
              }
              this.$store.commit('SHOW_DIALOG_EDITVIP',val)
          }
        },
        vip_info(){
            return this.$store.state.vip.vip
        },
        title(){
            // debugger
            if(this.show_dialog == 'add')   return '添加会员'
            if(this.show_dialog == 'valid') return '会员信息验证'
            return '修改会员';
        },
        birthday(){
            if(this.child.birthday) return this.child.birthday.split('T')[0];
            return ''
        }
    },
    methods:{
        empty_value(){
            this.mobile           = "";
            this.name             = "";
            this.user_group       = "vip";
            this.addr_act         = "";
            this.signed           = false;
            this.sex              = false;
            this.child.birthday   = "";
            this.child.sex        = true;
            this.spec_info.userid = '';
            this.spec_info.valid = false;
        },
        init_value(){
            // debugger
            if(this.show_dialog == 'add'){
                return this.empty_value()
            }
            if(!this.vip_info.mobile) return this.empty_value();
            
            this.mobile           = this.vip_info.mobile          ;
            this.name             = this.vip_info.name            ;
            this.user_group       = this.vip_info.user_group      ;
            this.addr_act         = this.vip_info.addr_act        ;
            this.signed           = this.vip_info.signed          ;
            this.sex              = this.vip_info.sex             ;
            this.child.birthday   = this.vip_info.child&&this.vip_info.child.birthday?this.vip_info.child.birthday.split(' ')[0]:""  ;
            this.child.sex        = this.vip_info.child&&this.vip_info.child.sex       ;
            this.spec_info.userid = this.vip_info.spec_info.userid;
            this.spec_info.valid  = this.vip_info.spec_info.valid;
        },
        save_menu (date) {
          console.log("data select change:",date)
          this.$refs.menu.save(date)
        },
        is_valide_mobiel(val){
            if(/^1[345789]\d{9}$/.test(val)) return true;
            return "不正确的手机格式"
        },
        valide_userid(){
            
            return isValidCID(this.spec_info.userid);
        },
        is_valide_userid(val){
            if(val ==""){
                return true;
            }
           let isok = isValidCID(val);
           if(isok) return true;
           return "身份证格式不正确"
        },
        check_valid(){
            let self = this;
            let name = this.name;
            if(name.length < 2 || name.indexOf('小姐') >=0 || name.indexOf('女士') >=0 || name.indexOf('先生') >=0){
                this.$notify({group: 'msgpad', type: 'error', title: '姓名格式不正确', text: '', duration: 500, })
                return false;
            }
            base_api({
                    schema:'vip',
                    method:'post',
                    params:{oper:'idvalid'},
                    data:{
                        name   :self.name,
                        mobile :self.mobile,
                        userid :self.spec_info.userid,
                    }}).then(resp=>{
                      // debugger
                      self.$store.commit("VIP_SET_VIP_INFO", resp.data);

                      self.$notify({
                            group : 'msgpad',
                            type  : 'success',
                            title : '认证成功',
                            text  : '姓名与身份证信息一致'
                      })
                      self.init_value();
                      if(self.show_dialog == 'valid'){
                          self.show_dialog = false;
                      }
                    }).catch(err=>{
                        self.$notify({
                            group : 'msgpad',
                            type  : 'error',
                            title : '认证失败',
                            text  : err.response?err.response.data:err.message
                        })
                    })
        },
        create_record(){
            console.log("click")
            let self = this;
            debugger
            let ok = self.$refs.form.validate();
            if (!ok) return;
                base_api({
                    schema:'vip',
                    method:'post',
                    params:{oper:self.show_dialog},
                    data:{
                        oper             : self.show_dialog =="add"?"add":"edit",
                        mobile           : self.mobile           ,
                        name             : self.name             ,
                        user_group       : self.user_group       ,
                        addr_act         : self.addr_act         ,
                        signed           : self.signed           ,
                        sex              : self.sex              ,
                        child :{
                            birthday   : self.child.birthday   ,
                            sex        : self.child.sex        
                        },
                        spec_info:{
                            userid : self.spec_info.userid ,
                            valid  : self.spec_info.valid
                        },
                    }
                }).then(resp=>{
                    self.$notify({group: 'msgpad', type: 'success', title: '操作成功！', text: '', duration: 500, })
                    // self.init_value();
                    self.$store.commit("VIP_SET_VIP_INFO", resp.data);
                    if(self.show_dialog =="add"){
                        self.$store.commit("VIP_SET_VIP_SAVED", []);
                        self.$store.commit("PRODUCTS_PREPARE_LIST", []);
                    }
                    self.$store.commit("PRODUCTS_RESET_VIP_PRICE", resp.data.user_group);
                    self.show_dialog = false;

                }).catch(err=>{
                    self.$notify({
                        group : 'msgpad',
                        type  : 'error',
                        title : '操作失败！',
                        text  : err.response?err.response.data:err.message
                    })
                }).then(_=>{
                    // debugger;
                    self.doing = false;
                })
        }
    },
    components:{},
    watch:{
        show_dialog(val,old){
            console.log("show_dialog :",val,old);
            if(val){
               this.init_value();
            }else{
                this.doing = false;
            }
        },
        menu (val) {
          val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
        }
    },
    directives: {},
    mounted :function(){},
    data () {
        return {
            mobile     : "",
            name       : "",
            user_group : "vip",
            addr_act   : "",
            signed     :false,
            sex        :false,
            child : {
                birthday : "",
                sex      : true
            },
            spec_info : {
                userid : "",
                valid  :false
            },
            vip_type:[
                {value:'vip',text:'注册会员'},
                {value:'copper',text:'铜牌会员'},
                {value:'silver',text:'银牌会员'},
                {value:'gold',text:'金牌会员'},
                {value:'diamond',text:'钻石会员'}],
            doing   :false,
            menu:false
        }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_vip_edit.vue